/* Rafaela Donata Relaunch 2026 – Theme-Skript (ohne Abhängigkeiten) */
(function () {
  'use strict';
  var S = window.rdShop || { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var eur = function (cents) { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var img = function (u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };

  /* ---------- Mobiles Menü ---------- */
  var drawer = $('#rdDrawerNav');
  var burger = $('[data-rd-burger]');
  if (drawer && burger) {
    burger.addEventListener('click', function () { drawer.hidden = false; burger.setAttribute('aria-expanded', 'true'); });
    var closeNav = function () { drawer.hidden = true; burger.setAttribute('aria-expanded', 'false'); };
    var nc = $('[data-rd-nav-close]', drawer); if (nc) nc.addEventListener('click', closeNav);
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('a')) closeNav(); });
  }

  /* ---------- Warenkorb (Drawer) ---------- */
  var cartEl = $('#rdCart');
  function setCount(n) { $$('[data-rd-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function openCart() { if (!cartEl) return; cartEl.classList.add('rd-open'); cartEl.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (!cartEl) return; cartEl.classList.remove('rd-open'); cartEl.setAttribute('aria-hidden', 'true'); }
  function renderCart(c) {
    setCount(c.item_count);
    var items = $('#rdCartItems'), foot = $('#rdCartFoot');
    if (!items || !foot) return;
    if (!c.items.length) {
      items.innerHTML = '<p class="rd-empty">Ihr Warenkorb ist noch leer.</p>';
      foot.innerHTML = '<a class="rd-btn" href="' + esc(S.root) + '" data-rd-close>Weiter einkaufen</a>';
      return;
    }
    items.innerHTML = c.items.map(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="rd-card__m">' + esc((it.options_with_values && it.options_with_values[0] ? it.options_with_values[0].name + ' ' : '') + it.variant_title) + '</div>' : '';
      return '<div class="rd-ci"><img src="' + esc(img(it.image, 200)) + '" alt="" width="76" height="76"><div><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="rd-card__m">Anzahl ' + it.quantity + '</div><button type="button" data-rd-rm="' + esc(it.key) + '">Entfernen</button></div><strong>' + eur(it.final_line_price) + '</strong></div>';
    }).join('');
    foot.innerHTML = '<div class="rd-row"><span>Zwischensumme</span><span>' + eur(c.total_price) + '</span></div>' +
      '<small>inkl. MwSt. · versandkostenfrei innerhalb Deutschlands</small>' +
      '<form action="' + esc(S.cart) + '" method="post"><button type="submit" name="checkout" class="rd-btn">Zur Kasse</button></form>' +
      '<a class="rd-cart__link" href="' + esc(S.cart) + '">Warenkorb ansehen</a>';
  }
  function loadCart() { return fetch(S.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-rd-cart-open]');
    if (op && cartEl) { e.preventDefault(); loadCart().then(openCart); return; }
    if (e.target.closest('[data-rd-close]')) { closeCart(); return; }
    var rm = e.target.closest('[data-rd-rm]');
    if (rm) {
      rm.disabled = true;
      fetch(S.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: rm.getAttribute('data-rd-rm'), quantity: 0 }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); if (drawer) drawer.hidden = true; } });

  /* ---------- Produktseite ---------- */
  $$('[data-rd-product]').forEach(function (root) {
    var main = $('.rd-pgal__main img', root);
    $$('[data-rd-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = b.getAttribute('data-rd-thumb'); }
        $$('[data-rd-thumb]', root).forEach(function (x) { x.classList.toggle('rd-on', x === b); });
      });
    });
    var form = $('form.rd-product-form', root);
    if (!form) return;
    var idInput = $('[data-rd-variant-id]', form), addBtn = $('[data-rd-add]', form), err = $('[data-rd-error]', form);
    var priceEl = $('[data-rd-price]', root), cmpEl = $('[data-rd-compare]', root), stock = $('[data-rd-stock]', form);
    var stockHTML = stock ? stock.innerHTML : '';
    $$('[data-rd-variant]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        idInput.value = b.getAttribute('data-rd-variant');
        $$('[data-rd-variant]', form).forEach(function (x) { x.classList.toggle('rd-on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        if (priceEl) priceEl.textContent = b.getAttribute('data-price');
        if (cmpEl) { var c = b.getAttribute('data-compare'); cmpEl.textContent = c; cmpEl.hidden = !c; }
        var ok = b.getAttribute('data-available') === 'true';
        if (addBtn) addBtn.disabled = !ok;
        if (stock) stock.innerHTML = ok ? stockHTML : '<strong>Derzeit nicht verfügbar</strong>';
        var u = new URL(location.href); u.searchParams.set('variant', idInput.value); history.replaceState(null, '', u.toString());
      });
    });
    form.addEventListener('submit', function (e) {
      if (!cartEl) return;
      e.preventDefault();
      if (err) err.hidden = true;
      addBtn.disabled = true;
      var label = addBtn.textContent; addBtn.textContent = 'Wird hinzugefügt …';
      fetch(S.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return loadCart(); })
        .then(function () { openCart(); })
        .catch(function (j) { if (err) { err.textContent = (j && (j.description || j.message)) || 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.'; err.hidden = false; } })
        .then(function () { addBtn.disabled = false; addBtn.textContent = label; });
    });
  });

  /* ---------- Empfehlungen ---------- */
  $$('[data-rd-recs]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('[data-rd-recs]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Kategorieseite: Filter, Preis, Sortierung, Nachladen ---------- */
  $$('[data-rd-collection]').forEach(function (root) {
    var grid = $('[data-rd-grid]', root); if (!grid) return;
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 20;
    var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1;
    var sectionId = root.getAttribute('data-section-id');
    var qs = new URLSearchParams(location.search);
    var cards = $$('.rd-card', grid).map(function (el, i) { return { el: el, i: i, metal: el.getAttribute('data-metal'), price: +el.getAttribute('data-price'), created: +el.getAttribute('data-created') }; });
    var toolbar = $('[data-rd-toolbar]', root), metalsEl = $('[data-rd-metals]', root);
    var rmin = $('[data-rd-rmin]', root), rmax = $('[data-rd-rmax]', root), sortEl = $('[data-rd-sort]', root);
    var state = { metal: qs.get('m') || '', shown: pageSize, lo: 0, hi: 0 };
    var ORDER = ['Silber', 'Gelbgold', 'Roségold', 'Bicolor', 'Textil'];

    function setupControls(keepValues) {
      var prices = cards.map(function (c) { return c.price / 100; });
      if (!prices.length) return;
      var lo = Math.floor(Math.min.apply(null, prices)), hi = Math.ceil(Math.max.apply(null, prices));
      var curMin = keepValues ? +rmin.value : (qs.get('min') ? +qs.get('min') : lo);
      var curMax = keepValues ? +rmax.value : (qs.get('max') ? +qs.get('max') : hi);
      var wasFull = keepValues && +rmax.value >= state.hi;
      state.lo = lo; state.hi = hi;
      [rmin, rmax].forEach(function (r) { r.min = lo; r.max = hi; });
      rmin.value = Math.max(lo, Math.min(curMin, hi));
      rmax.value = wasFull ? hi : Math.max(lo, Math.min(curMax, hi));
      var present = ORDER.filter(function (m) { return cards.some(function (c) { return c.metal === m; }); });
      metalsEl.innerHTML = '<button type="button" class="rd-fbtn' + (!state.metal ? ' rd-on' : '') + '" data-m="">Alle</button>' +
        present.map(function (m) { return '<button type="button" class="rd-fbtn' + (state.metal === m ? ' rd-on' : '') + '" data-m="' + m + '">' + m + '</button>'; }).join('');
      toolbar.hidden = false;
    }
    function draw() {
      var mn = Math.min(+rmin.value, +rmax.value), mx = Math.max(+rmin.value, +rmax.value);
      $('[data-rd-pmin]', root).textContent = mn + ' €'; $('[data-rd-pmax]', root).textContent = mx + ' €';
      var span = (state.hi - state.lo) || 1, fill = $('[data-rd-pfill]', root);
      fill.style.left = ((mn - state.lo) / span * 100) + '%'; fill.style.right = (100 - (mx - state.lo) / span * 100) + '%';
      var r = cards.filter(function (c) { var p = c.price / 100; return (!state.metal || c.metal === state.metal) && p >= mn && p <= mx; });
      var s = sortEl.value;
      if (s === 'new') r.sort(function (a, b) { return b.created - a.created; });
      else if (s === 'asc') r.sort(function (a, b) { return a.price - b.price; });
      else if (s === 'desc') r.sort(function (a, b) { return b.price - a.price; });
      else r.sort(function (a, b) { return a.i - b.i; });
      cards.forEach(function (c) { c.el.hidden = true; });
      r.forEach(function (c, idx) { grid.appendChild(c.el); c.el.hidden = idx >= state.shown; });
      $('[data-rd-count]', root).textContent = r.length + ' Artikel';
      $('[data-rd-empty]', root).hidden = r.length > 0;
      var more = $('[data-rd-more]', root), rest = r.length - state.shown;
      more.innerHTML = rest > 0 ? '<button type="button" class="rd-btn rd-btn--ghost">Weitere ' + Math.min(pageSize, rest) + ' Artikel laden</button>' : '';
      var mb = more.querySelector('button'); if (mb) mb.onclick = function () { state.shown += pageSize; draw(); };
    }
    metalsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-m]'); if (!b) return;
      state.metal = b.getAttribute('data-m'); state.shown = pageSize;
      $$('[data-m]', metalsEl).forEach(function (x) { x.classList.toggle('rd-on', x === b); });
      draw();
    });
    rmin.addEventListener('input', function () { state.shown = pageSize; draw(); });
    rmax.addEventListener('input', function () { state.shown = pageSize; draw(); });
    sortEl.addEventListener('change', draw);
    setupControls(false); draw();

    /* Weitere Seiten im Hintergrund laden, damit Filter das ganze Sortiment erfassen */
    if (pages > 1 && sectionId) {
      var load = function (n) {
        if (n > pages) return;
        var u = new URL(location.href); u.searchParams.set('page', n); u.searchParams.set('section_id', sectionId);
        fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          $$('[data-rd-grid] .rd-card', d).forEach(function (el) {
            el.hidden = true; grid.appendChild(el);
            cards.push({ el: el, i: cards.length, metal: el.getAttribute('data-metal'), price: +el.getAttribute('data-price'), created: +el.getAttribute('data-created') });
          });
          setupControls(true); draw(); load(n + 1);
        }).catch(function () {});
      };
      load(2);
    }
  });
})();
